import React, { useState, useEffect } from "react";
import $ from "jquery";
import ProductSearch from "../../../../../components/products/productSearch/index";
import ProductFilters from "../../../../../components/products/ProductFilters/index";
import ProductTable from "../../../../../components/products/productTable/index";
import ProductModal from "../../../../../components/products/ProductModals/index";
import Dashboard from "../../../../../layouts/dashboard";
import { Spinner } from "../../../../../components";
import ProductPagination from "../../../../../components/products/productPagination";
import { Link } from "react-router-dom";
import axios from "axios";
import config from "../../../../../config";
import { useSelector } from "react-redux";

const ProductList = () => {
  const [loadPage, setLoadPage] = useState(true);

  useEffect(() => {
    let tim1 = setTimeout(() => {
      setLoadPage(false);
    }, 100);

    const script = `
        new HSGoTo('.js-go-to');
        new HSHeader('#header').init();
        new HSMegaMenu('.js-mega-menu', {"desktop": {"position": "left"}});
    `;

    $("body").append(`<script className="homescript">${script}</script>`);

    return () => {
      clearTimeout(tim1);
      $(".homescript").remove();
    };
  }, []);

  return (
    <>
      {loadPage ? (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            height: "100vh",
            width: "100%",
            position: "fixed",
            left: 0,
            top: 0,
          }}
        >
          <Spinner color={"success"} size={3} />
        </div>
      ) : (
        <Main />
      )}
    </>
  );
};

const Main = () => {
  const [products, setProducts] = useState([]);
  const [filteredProducts, setFilteredProducts] = useState([]);
  const [filters, setFilters] = useState({ category: "", vendor: "" });
  const [searchQuery, setSearchQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(1);

  const [selectedProduct, setSelectedProduct] = useState(null);
  const [modalType, setModalType] = useState("");
  const token = useSelector((state) => state.auth.token.value);

  const getProducts = async () => {
    try {
      const response = await axios.get(`${config.apiUrl}/products`);
      setProducts(response.data.data.products);
      setFilteredProducts(response.data.data.products);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    getProducts();
  }, []);

  useEffect(() => {
    // Appliquer les filtres et la recherche
    const applyFiltersAndSearch = () => {
      let tempProducts = [...products];

      if (searchQuery) {
        tempProducts = tempProducts.filter(
          (product) =>
            product.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
            product.category.name
              .toLowerCase()
              .includes(searchQuery.toLowerCase())
          //   ||
          // product.vendor.toLowerCase().includes(searchQuery.toLowerCase())
        );
      }

      if (filters.category) {
        tempProducts = tempProducts.filter((product) =>
          product.category.name
            .toLowerCase()
            .includes(filters.category.toLowerCase())
        );
      }

      // if (filters.vendor) {
      //   tempProducts = tempProducts.filter((product) =>
      //     product.vendor.toLowerCase().includes(filters.vendor.toLowerCase())
      //   );
      // }

      setFilteredProducts(tempProducts);
    };

    applyFiltersAndSearch();
  }, [searchQuery, filters, products]);

  const productsPerPage = 8;
  const idLastProduct = currentPage * productsPerPage;
  const idFirstProduct = idLastProduct - productsPerPage;
  const currentProducts = filteredProducts.slice(idFirstProduct, idLastProduct);

  const numberOfPages = Math.ceil(products.length / productsPerPage);

  const handleDelete = async (product) => {
    try {
      const response = await axios.delete(
        `${config.apiUrl}/destroy/product/${product.id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );
      console.log(response.data);

      // getProducts()
      setProducts(products.filter((p) => p.id !== product.id));
      console.log("admin products", products);
      setFilteredProducts(filteredProducts.filter((p) => p.id !== product.id));
    } catch (error) {
      console.error(error);
    }
  };

  const handleEdit = async (updatedProduct) => {
    try {
      const response = await axios.put(
        `${config.apiUrl}/update/product/${updatedProduct.id}`,
        updatedProduct,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );
      console.log(response.data);

      // getProducts()
      const updatedProducts = products.map((product) =>
        product.id === updatedProduct.id ? updatedProduct : product
      );
      setProducts(updatedProducts);
      setFilteredProducts(updatedProducts);
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <>
      <Dashboard>
        <main id="content" role="main">
          <div
            className="container content-space-6 content-space-t-lg-1 content-space-b-lg-3"
            style={{ maxWidth: "100rem", height: "100vh" }}
          >
            <div className="mb-4 d-flex justify-content-between align-items-center">
              <ProductSearch setSearchQuery={setSearchQuery} />
              <div>
                <Link to={"/product_managment/add"}>
                  <button
                    className="btn btn-info"
                    data-bs-toggle="modal"
                    data-bs-target="#addProductModal"
                  >
                    Add Product
                  </button>
                </Link>

                <button
                  className="btn btn-danger ms-2"
                  data-bs-toggle="modal"
                  data-bs-target="#addProductModal"
                >
                  Delete Product(s)
                </button>
              </div>
            </div>
            {/* <ProductFilters setFilters={setFilters} /> */}
            <ProductTable
              products={currentProducts}
              setSelectedProduct={setSelectedProduct}
              onEdit={(product) => {
                setModalType("edit");
                setSelectedProduct(product);
              }}
              onDelete={(product) => {
                setModalType("delete");
                setSelectedProduct(product);
              }}
            />

            <ProductPagination
              currentPage={currentPage}
              totalPages={numberOfPages}
              setCurrentPage={setCurrentPage}
            />
          </div>
        </main>
        <ProductModal
          // selectedProduct={selectedProduct}
          // setProducts={setProducts}
          // setFilteredProducts={setFilteredProducts}
          // setSelectedProduct={setSelectedProduct}

          type={modalType}
          product={selectedProduct}
          onDelete={handleDelete}
          onSave={handleEdit}
        />
      </Dashboard>{" "}
    </>
  );
};

export default ProductList;
